<template>
  <v-container class="pa-0 ma-0 container-special-infoCotacao">
    <v-flex xs12 class="background">
      <v-toolbar height="56" color="primary">
        <v-toolbar-title id="idCabecalhoJanela" class="subheading white--text">
          Cobertura
        </v-toolbar-title>
      </v-toolbar>
      <v-layout pa-5>
        <v-flex row wrap>
          COTAÇÃO
          <p>{{ formatarNumeroCotacao(id) }}</p>
        </v-flex>
        <v-flex row wrap>
          APÓLICE
          <p>{{ formatarNumeroApolice(apoliceNumeroProposta) }}</p>
        </v-flex>
        <v-flex>
          CNPJ
          <p>{{ formatarCnpj(proponenteCnpj) }}</p>
        </v-flex>
        <v-flex
          >RAZÃO SOCIAL
          <p>{{ proponenteRazaoSocial }}</p>
        </v-flex>
        <v-flex
          >ÍTENS
          <p>{{ quantidadeItens }}</p>
        </v-flex>
        <v-flex>
          VIGÊNCIA
          <p>{{ formatarData(dateInicio) }}</p>
        </v-flex>
        <v-flex>
          <br />
          <p>{{ formatarData(dateFim) }}</p>
        </v-flex>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>

      </v-layout>
    </v-flex>
    <v-container style="max-width: 100%!important" class="ma-0 container-special-infoCotacao pa-0 background data-table">
      <v-form>
        <v-card elevation="0">
          <v-card-title>
            <v-flex xs12 sm11 md6 lg4>
              <transition name="fade">
                <v-flex xs1 v-if="!filtro.pesquisa.opened">
                  <v-btn
                    v-if="!filtro.pesquisa.opened"
                    @click="filtroFunctions().abrirFiltroPesquisa()"
                    color="primary"
                    round
                    outline
                    icon
                    ><v-icon>search</v-icon></v-btn
                  >
                </v-flex>
                <v-flex v-else>
                  <v-text-field
                    v-model="filtro.pesquisa.conteudo"
                    prepend-icon="search"
                    @click:prepend="filtroFunctions().fecharFiltroPesquisa()"
                    @blur="filtroFunctions().fecharFiltroPesquisa()"
                    label="Busca"
                    autofocus
                    clearable
                  ></v-text-field>
                </v-flex>
              </transition>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn
              @click="deletarItens"
              v-if="selected.length >= 1"
              color="error"
              round
            >
              {{
                selected.length === 1 ? "Excluir Ítem" : "Excluir Ítens"
              }}</v-btn
            >
          </v-card-title>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="errosFiltrados"
            :search="filtro.pesquisa.conteudo"
            :pagination.sync="pagination"
            :select-all="!camposDisabled"
            :rows-per-page-items="[10, 25, 50, 100, 150, 200, 300, 400, 500]"
            rows-per-page-text="Itens por página"
            item-key="item"
            class="elevation-0"
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ props.header.text }}
                  </span>
                </template>
                <span v-if="props.header.tool">
                  {{ props.header.tool }}
                </span>
                <span v-else>{{ props.header.text }}</span>
              </v-tooltip>
            </template>
            <template v-slot:items="props">
              <td
                v-if="!camposDisabled"
                :active="props.selected"
                @click="props.selected = !props.selected"
              >
                <v-checkbox
                  class="checkbox"
                  color="primary"
                  :input-value="props.selected"
                  primary
                  hide-details
                ></v-checkbox>
              </td>
              <td class="themeGrey--text pa-4">
                {{ formatarNumeroItem(props.item.item) }}
              </td>
              <td class="pa-0 item-faltante">
                <v-tooltip
                  v-if="props.item.erro"
                  right
                  color="error"
                  max-width="350px"
                >
                  <template v-slot:activator="{ on }">
                    <span class="error--text" v-on="on">⬤</span>
                  </template>
                  <span
                    >Não foi possivel avaliar este item devido a um ou mais
                    erros nos dados informados. Consulte a FIPE, corrija o(s)
                    erro(s) direto na linha e clique em "Reavaliar Item" para
                    reprocessar os dados.</span
                  >
                </v-tooltip>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.placa"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{ props.item.placa
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.placa"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  props.item.placa
                }}</span>
              </td>

              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.tipoCobertura"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{
                    buscarTitulo(
                      props.item.tipoCobertura,
                      campos.tipoCoberturaList
                    )
                  }}
                  <template v-slot:input>
                    <v-select
                      :items="campos.tipoCoberturaList"
                      v-model="props.item.tipoCobertura"
                      item-text="titulo"
                      :item-value="item => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item.tipoCobertura,
                    campos.tipoCoberturaList
                  )
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.tipoDeContratacao"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{
                    buscarTitulo(
                      props.item.tipoDeContratacao,
                      campos.tipoDeContratacaoList
                    )
                  }}
                  <template v-slot:input>
                    <v-select
                      :items="campos.tipoDeContratacaoList"
                      v-model="props.item.tipoDeContratacao"
                      item-text="titulo"
                      :item-value="item => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item.tipoDeContratacao,
                    campos.tipoDeContratacaoList
                  )
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.percAjusteVmrOuVd"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{ toPercentString(props.item.percAjusteVmrOuVd)
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.percAjusteVmrOuVd"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  toPercentString(props.item.percAjusteVmrOuVd)
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.tipoDeFranquia"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{
                    buscarTitulo(
                      props.item.tipoDeFranquia,
                      campos.tipoDeFranquiaList
                    )
                  }}
                  <template v-slot:input>
                    <v-select
                      :items="campos.tipoDeFranquiaList"
                      v-model="props.item.tipoDeFranquia"
                      item-text="titulo"
                      :item-value="item => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item.tipoDeFranquia,
                    campos.tipoDeFranquiaList
                  )
                }}</span>
              </td>

              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.vlrFipe"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{ formatMoney(props.item.vlrFipe)
                  }}<template v-slot:input>
                    <v-text-field
                      type="number"
                      v-model="props.item.vlrFipe"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  formatMoney(props.item.vlrFipe)
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="erros[props.item.item].vdContratado.ativo">
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.vdContratado"
                    lazy
                    large
                    persistent
                    :disabled="props.item.tipoDeContratacao && props.item.tipoDeContratacao.id === 2"
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                    ><span
                      :class="{
                        errorTaxa: erros[props.item.item].vdContratado.erro
                      }"
                      >{{ formatMoney(props.item.vdContratado) }}</span
                    >
                    <template v-slot:input>
                      <v-text-field
                        type="number"
                        v-model="props.item.vdContratado"
                        label="Editar"
                        single-line
                        :rules="[
                          ...regras.notNull,
                        ]"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(props.item.vdContratado)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="erros[props.item.item].danosMateriais.ativo">
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.danosMateriais"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                  >
                    <span
                      :class="{
                        errorTaxa: erros[props.item.item].danosMateriais.erro
                      }"
                      >{{ formatMoney(props.item.danosMateriais) }}</span
                    >
                    <template v-slot:input>
                      <v-text-field
                        type="number"
                        v-model="props.item.danosMateriais"
                        label="Editar"
                        single-line
                        :rules="[
                          ...regras.notNull,
                          ...regras.limites(limitesTaxasBasicas.danosMateriais)
                        ]"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(props.item.danosMateriais)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="erros[props.item.item].vlrFranquiaDanosMateriais.ativo"
                >
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.vlrFranquiaDanosMateriais"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                    >{{
                      props.item.vlrFranquiaDanosMateriais
                        ? formatMoney(props.item.vlrFranquiaDanosMateriais)
                        : "-"
                    }}
                    <template v-slot:input>
                      <v-select
                        :items="campos.vlrFranquiaDanosMateriaisList"
                        v-model="props.item.vlrFranquiaDanosMateriais"
                        item-text="titulo"
                        item-value="titulo"
                        label="Editar"
                        :rules="regras.notNull"
                      ></v-select>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(props.item.vlrFranquiaDanosMateriais)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="erros[props.item.item].danosCorporais.ativo">
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.danosCorporais"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                  >
                    <span
                      :class="{
                        errorTaxa: erros[props.item.item].danosCorporais.erro
                      }"
                      >{{ formatMoney(props.item.danosCorporais) }}</span
                    ><template v-slot:input>
                      <v-text-field
                        type="number"
                        v-model="props.item.danosCorporais"
                        label="Editar"
                        single-line
                        :rules="[
                          ...regras.notNull,
                          ...regras.limites(limitesTaxasBasicas.danosCorporais)
                        ]"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(props.item.danosCorporais)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="erros[props.item.item].danosMoraisEEsteticos.ativo"
                >
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.danosMoraisEEsteticos"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                    ><span
                      :class="{
                        errorTaxa:
                          erros[props.item.item].danosMoraisEEsteticos.erro
                      }"
                      >{{ formatMoney(props.item.danosMoraisEEsteticos) }}</span
                    ><template v-slot:input>
                      <v-text-field
                        type="number"
                        v-model="props.item.danosMoraisEEsteticos"
                        label="Editar"
                        single-line
                        :rules="[
                          ...regras.notNull,
                          ...regras.limites(limitesTaxasBasicas.danosMateriais)
                        ]"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(props.item.danosMoraisEEsteticos)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.garantiaUnica"
                  lazy
                  large
                  persistent
                  @save="saveGarantiaUnica(props.item.item,props.item
                      .garantiaUnica)"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  {{ buscarTitulo(props.item.garantiaUnica, simOuNao) }}
                  <template v-slot:input>
                    <v-radio-group
                      v-model="props.item.garantiaUnica"
                      :mandatory="false"
                      row
                    >
                      <v-radio
                        v-for="item in simOuNao"
                        :key="item.titulo"
                        :label="item.titulo"
                        :value="item.id"
                      ></v-radio>
                    </v-radio-group>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(props.item.garantiaUnica, simOuNao)
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="erros[props.item.item].vlrGarantiaUnica.ativo">
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.vlrGarantiaUnica"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                  >
                    <span
                      :class="{
                        errorTaxa: erros[props.item.item].vlrGarantiaUnica.erro
                      }"
                      >{{ formatMoney(props.item.vlrGarantiaUnica) }}</span
                    ><template v-slot:input>
                      <v-text-field
                        type="number"
                        v-model="props.item.vlrGarantiaUnica"
                        label="Editar"
                        single-line
                        :rules="[
                          ...regras.notNull,
                          ...regras.limites(
                            limitesTaxasBasicas.vlrGarantiaUnica
                          )
                        ]"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(props.item.vlrGarantiaUnica)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="erros[props.item.item].vlrFranquiaGarantiaUnica.ativo"
                >
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.vlrFranquiaGarantiaUnica"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                    >{{
                      props.item.vlrFranquiaGarantiaUnica
                        ? formatMoney(props.item.vlrFranquiaGarantiaUnica)
                        : "-"
                    }}
                    <template v-slot:input>
                      <v-select
                        :items="campos.vlrFranquiaGarantiaUnicaList"
                        v-model="props.item.vlrFranquiaGarantiaUnica"
                        item-text="titulo"
                        item-value="titulo"
                        label="Editar"
                        :rules="regras.notNull"
                      ></v-select>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(props.item.vlrFranquiaGarantiaUnica)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="erros[props.item.item].appMorte.ativo">
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.appMorte"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                    ><span
                      :class="{
                        errorTaxa: erros[props.item.item].appMorte.erro
                      }"
                      >{{ formatMoney(props.item.appMorte) }}</span
                    ><template v-slot:input>
                      <v-text-field
                        type="number"
                        v-model="props.item.appMorte"
                        label="Editar"
                        single-line
                        :rules="[
                          ...regras.notNull,
                          ...regras.limites(limitesTaxasBasicas.appMorte)
                        ]"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(props.item.appMorte)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="erros[props.item.item].appInvalidez.ativo">
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.appInvalidez"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                    ><span
                      :class="{
                        errorTaxa: erros[props.item.item].appInvalidez.erro
                      }"
                      >{{ formatMoney(props.item.appInvalidez) }}</span
                    ><template v-slot:input>
                      <v-text-field
                        type="number"
                        v-model="props.item.appInvalidez"
                        label="Editar"
                        single-line
                        :rules="[
                          ...regras.notNull,
                          ...regras.limites(limitesTaxasBasicas.appInvalidez)
                        ]"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(props.item.appInvalidez)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="
                    erros[props.item.item]
                      .despesasMedicasHospitalaresEOdontologicas.ativo
                  "
                >
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="
                      props.item.despesasMedicasHospitalaresEOdontologicas
                    "
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                    ><span
                      :class="{
                        errorTaxa:
                          erros[props.item.item]
                            .despesasMedicasHospitalaresEOdontologicas.erro
                      }"
                      >{{
                        formatMoney(
                          props.item.despesasMedicasHospitalaresEOdontologicas
                        )
                      }}</span
                    ><template v-slot:input>
                      <v-text-field
                        type="number"
                        v-model="
                          props.item.despesasMedicasHospitalaresEOdontologicas
                        "
                        label="Editar"
                        single-line
                        :rules="[
                          ...regras.notNull,
                          ...regras.limites(
                            limitesTaxasBasicas.despesasMedicasHospitalaresEOdontologicas
                          )
                        ]"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(
                      props.item.despesasMedicasHospitalaresEOdontologicas
                    )
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="
                    erros[props.item.item].coberturaAdicionalDespesasExtras
                      .ativo
                  "
                >
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="
                      props.item.coberturaAdicionalDespesasExtras
                    "
                    lazy
                    large
                    persistent
                    @save="saveDespesasExtras(props.item.item, props.item.coberturaAdicionalDespesasExtras)"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                  >
                    <span
                      :class="{
                        errorTaxa:
                          erros[props.item.item]
                            .coberturaAdicionalDespesasExtras.erro
                      }"
                      >{{
                        buscarTitulo(
                          props.item.coberturaAdicionalDespesasExtras,
                          simOuNao
                        )
                      }}</span
                    >
                    <template v-slot:input>
                      <v-radio-group
                        v-model="props.item.coberturaAdicionalDespesasExtras"
                        :mandatory="false"
                        row
                      >
                        <v-radio
                          v-for="item in simOuNao"
                          :key="item.titulo"
                          :label="item.titulo"
                          :value="item.id"
                        ></v-radio>
                      </v-radio-group>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    buscarTitulo(
                      props.item.coberturaAdicionalDespesasExtras,
                      simOuNao
                    )
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="!erros[props.item.item].desativarCampoDespesasExtras.ativo">
                  <span class="themeGrey--text">{{
                    formatMoney(props.item.despesasExtras)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.caminhaoBasculado"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  {{ buscarTitulo(props.item.caminhaoBasculado, simOuNao) }}
                  <template v-slot:input>
                    <v-radio-group
                      v-model="props.item.caminhaoBasculado"
                      :mandatory="false"
                      row
                    >
                      <v-radio
                        v-for="item in simOuNao"
                        :key="item.titulo"
                        :label="item.titulo"
                        :value="item.id"
                      ></v-radio>
                    </v-radio-group>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(props.item.caminhaoBasculado, simOuNao)
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.diasGarantZeroKm"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  {{
                    buscarTitulo(
                      props.item.diasGarantZeroKm,
                      campos.diasGarantZeroKmList
                    )
                  }}
                  <template v-slot:input>
                    <v-select
                      :items="campos.diasGarantZeroKmList"
                      v-model="props.item.diasGarantZeroKm"
                      item-text="titulo"
                      :item-value="item => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item.diasGarantZeroKm,
                    campos.diasGarantZeroKmList
                  )
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="
                    props.item.garantiaCompreensivaParaTumultos
                  "
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  {{
                    buscarTitulo(
                      props.item.garantiaCompreensivaParaTumultos,
                      simOuNao
                    )
                  }}
                  <template v-slot:input>
                    <v-radio-group
                      v-model="props.item.garantiaCompreensivaParaTumultos"
                      :mandatory="false"
                      row
                    >
                      <v-radio
                        v-for="item in simOuNao"
                        :key="item.titulo"
                        :label="item.titulo"
                        :value="item.id"
                      ></v-radio>
                    </v-radio-group>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item.garantiaCompreensivaParaTumultos,
                    simOuNao
                  )
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template>
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="
                      props.item.extCobAmericaDoSul
                    "
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                  >
                    {{
                      buscarTitulo(
                        props.item.extCobAmericaDoSul,
                        simOuNao
                      )
                    }}
                    <template v-slot:input>
                      <v-radio-group
                        v-model="props.item.extCobAmericaDoSul"
                        :disabled="props.item.tipoCobertura && props.item.tipoCobertura.id === tipoCoberturaComputed.tipoCobertura.RCF"
                        :mandatory="false"
                        row
                      >
                        <v-radio
                          v-for="item in simOuNao"
                          :key="item.titulo"
                          :label="item.titulo"
                          :value="item.id"
                        ></v-radio>
                      </v-radio-group>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    buscarTitulo(
                      props.item.extCobAmericaDoSul,
                      simOuNao
                    )
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template>
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="
                      props.item.rcfExtCobAmericaDoSul
                    "
                    lazy
                    large
                    persistent
                    @save="saveRcfExtCobAmericaDoSul(props.item.item,props.item
                      .rcfExtCobAmericaDoSul) "
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                  >
                    {{
                      buscarTitulo(
                        props.item.rcfExtCobAmericaDoSul,
                        simOuNao
                      )
                    }}
                    <template v-slot:input>
                      <v-radio-group
                        v-model="props.item.rcfExtCobAmericaDoSul"
                        :mandatory="false"
                        row
                      >
                        <v-radio
                          v-for="item in simOuNao"
                          :key="item.titulo"
                          :label="item.titulo"
                          :value="item.id"
                        ></v-radio>
                      </v-radio-group>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    buscarTitulo(
                      props.item.rcfExtCobAmericaDoSul,
                      simOuNao
                    )
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="!erros[props.item.item].desativarRcfExtCobAmericaDoSul.ativo">

                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.vlrRcfExtCobAmericaDoSul"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                    >{{ formatMoney(props.item.vlrRcfExtCobAmericaDoSul)
                    }}<template v-slot:input>
                      <v-text-field
                        v-model="props.item.vlrRcfExtCobAmericaDoSul"
                        label="Editar"
                        disabled
                        single-line
                        :rules="regras.notNull"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(props.item.vlrRcfExtCobAmericaDoSul)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="
                    props.item
                      .danosMateriaisADirigentesSociosEmpregadosEPrepostos
                  "
                  lazy
                  large
                  persistent
                  @save="saveDmDiregentes(props.item.item, props.item.danosMateriaisADirigentesSociosEmpregadosEPrepostos)"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  {{
                    buscarTitulo(
                      props.item
                        .danosMateriaisADirigentesSociosEmpregadosEPrepostos,
                      simOuNao
                    )
                  }}
                  <template v-slot:input>
                    <v-radio-group
                      v-model="
                        props.item
                          .danosMateriaisADirigentesSociosEmpregadosEPrepostos
                      "
                      :mandatory="false"
                      row
                    >
                      <v-radio
                        v-for="item in simOuNao"
                        :key="item.titulo"
                        :label="item.titulo"
                        :value="item.id"
                      ></v-radio>
                    </v-radio-group>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item
                      .danosMateriaisADirigentesSociosEmpregadosEPrepostos,
                    simOuNao
                  )
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="!erros[props.item.item].desativarDanosMateriaisADirigentesSociosEmpregadosEPrepostos.ativo">
                  <template
                    v-if="
                      erros[props.item.item]
                        .vlrDanosMateriaisADirigentesSociosEmpregadosEPrepostos
                        .ativo
                    "
                  >
                    <v-edit-dialog
                      class="item-color"
                      :return-value.sync="
                        props.item
                          .vlrDanosMateriaisADirigentesSociosEmpregadosEPrepostos
                      "
                      lazy
                      large
                      persistent
                      @save="save"
                      @cancel="cancel"
                      @open="open"
                      @close="close"
                      save-text="Salvar"
                      cancel-text="Cancelar"
                      v-if="!camposDisabled"
                      ><span
                        :class="{
                          errorTaxa:
                            erros[props.item.item]
                              .vlrDanosMateriaisADirigentesSociosEmpregadosEPrepostos
                              .erro
                        }"
                        >{{
                          formatMoney(
                            props.item
                              .vlrDanosMateriaisADirigentesSociosEmpregadosEPrepostos
                          )
                        }}</span
                      ><template v-slot:input>
                        <v-text-field
                          type="number"
                          v-model="
                            props.item
                              .vlrDanosMateriaisADirigentesSociosEmpregadosEPrepostos
                          "
                          label="Editar"
                          single-line

                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                    <span class="themeGrey--text" v-else>{{
                      formatMoney(
                        props.item
                          .vlrDanosMateriaisADirigentesSociosEmpregadosEPrepostos
                      )
                    }}</span>
                  </template>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="
                    props.item
                      .danosCorporaisADirigentesSociosEmpregadosEPrepostos
                  "
                  lazy
                  large
                  persistent
                  @save="saveDcDiregentes(props.item.item, props.item.danosCorporaisADirigentesSociosEmpregadosEPrepostos)"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  {{
                    buscarTitulo(
                      props.item
                        .danosCorporaisADirigentesSociosEmpregadosEPrepostos,
                      simOuNao
                    )
                  }}
                  <template v-slot:input>
                    <v-radio-group
                      v-model="
                        props.item
                          .danosCorporaisADirigentesSociosEmpregadosEPrepostos
                      "
                      :mandatory="false"
                      row
                    >
                      <v-radio
                        v-for="item in simOuNao"
                        :key="item.titulo"
                        :label="item.titulo"
                        :value="item.id"
                      ></v-radio>
                    </v-radio-group>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item
                      .danosCorporaisADirigentesSociosEmpregadosEPrepostos,
                    simOuNao
                  )
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="!erros[props.item.item].desativarDanosCorporaisADirigentesSociosEmpregadosEPrepostos.ativo">
                  <template
                    v-if="
                      erros[props.item.item]
                        .vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos
                        .ativo
                    "
                  >
                    <v-edit-dialog
                      class="item-color"
                      :return-value.sync="
                        props.item
                          .vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos
                      "
                      lazy
                      large
                      persistent
                      @save="save"
                      @cancel="cancel"
                      @open="open"
                      @close="close"
                      save-text="Salvar"
                      cancel-text="Cancelar"
                      v-if="!camposDisabled"
                      ><span
                        :class="{
                          errorTaxa:
                            erros[props.item.item]
                              .vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos
                              .erro
                        }"
                        >{{
                          formatMoney(
                            props.item
                              .vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos
                          )
                        }}</span
                      ><template v-slot:input>
                        <v-text-field
                          type="number"
                          v-model="
                            props.item
                              .vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos
                          "
                          label="Editar"
                          single-line

                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                    <span class="themeGrey--text" v-else>{{
                      formatMoney(
                        props.item
                          .vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos
                      )
                    }}</span>
                  </template>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                  <template
                    v-if="
                      erros[props.item.item]
                        .danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
                        .ativo
                    "
                  >
                    <v-edit-dialog
                      class="item-color"
                      :return-value.sync="
                        props.item
                          .danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
                      "
                      lazy
                      large
                      persistent
                      @save="save"
                      @cancel="cancel"
                      @open="open"
                      @close="close"
                      save-text="Salvar"
                      cancel-text="Cancelar"
                      v-if="!camposDisabled"
                      ><span
                        :class="{
                          errorTaxa:
                            erros[props.item.item]
                              .danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
                              .erro
                        }"
                        >{{
                          formatMoney(
                            props.item
                              .danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
                          )
                        }}</span
                      ><template v-slot:input>
                        <v-text-field
                          type="number"
                          v-model="
                            props.item
                              .danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
                          "
                          label="Editar"
                          single-line
                          :rules="[
                            ...regras.notNull,
                            ...regras.limites(
                              limitesTaxasBasicas.danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
                            )
                          ]"
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                    <span class="themeGrey--text" v-else>{{
                      formatMoney(
                        props.item
                          .danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
                      )
                    }}</span>
                  </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="
                    props.item.extensaoDeCoberturaRcfAVeiculosRebocados
                  "
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  {{
                    buscarTitulo(
                      props.item.extensaoDeCoberturaRcfAVeiculosRebocados,
                      simOuNao
                    )
                  }}
                  <template v-slot:input>
                    <v-radio-group
                      v-model="
                        props.item.extensaoDeCoberturaRcfAVeiculosRebocados
                      "
                      :mandatory="false"
                      row
                    >
                      <v-radio
                        v-for="item in simOuNao"
                        :key="item.titulo"
                        :label="item.titulo"
                        :value="item.id"
                      ></v-radio>
                    </v-radio-group>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item.extensaoDeCoberturaRcfAVeiculosRebocados,
                    simOuNao
                  )
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="
                    erros[props.item.item].coberturaAdicionalCarroceria.ativo
                  "
                >
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.coberturaAdicionalCarroceria"
                    lazy
                    large
                    persistent
                    @save="saveCarroceria(props.item.item, props.item.coberturaAdicionalCarroceria)"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                  >
                    <span
                      :class="{
                        errorTaxa:
                          erros[props.item.item].coberturaAdicionalCarroceria
                            .erro
                      }"
                      >{{
                        buscarTitulo(
                          props.item.coberturaAdicionalCarroceria,
                          simOuNao
                        )
                      }}</span
                    >
                    <template v-slot:input>
                      <v-radio-group
                        v-model="props.item.coberturaAdicionalCarroceria"
                        :mandatory="false"
                        row
                      >
                        <v-radio
                          v-for="item in simOuNao"
                          :key="item.titulo"
                          :label="item.titulo"
                          :value="item.id"
                        ></v-radio>
                      </v-radio-group>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    buscarTitulo(
                      props.item.coberturaAdicionalCarroceria,
                      simOuNao
                    )
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="!erros[props.item.item].desativarCampoCarroceria.ativo">
                  <template v-if="erros[props.item.item].coberturaAdicionalCarroceria.ativo">

                    <v-edit-dialog
                      class="item-color"
                      :return-value.sync="props.item.descrCarroceria"
                      lazy
                      large
                      persistent
                      @save="save"
                      @cancel="cancel"
                      @open="open"
                      @close="close"
                      save-text="Salvar"
                      cancel-text="Cancelar"
                      v-if="!camposDisabled"
                      >{{
                        buscarTitulo(
                          props.item.descrCarroceria,
                          campos.descrCarroceriaList
                        )
                      }}
                      <template v-slot:input>
                        <v-select
                          :items="campos.descrCarroceriaList"
                          v-model="props.item.descrCarroceria"
                          item-text="titulo"
                          :item-value="item => item"
                          label="Editar"
                          :rules="regras.notNull"
                          :value-comparator="comparador"
                        ></v-select>
                      </template>
                    </v-edit-dialog>
                    <span class="themeGrey--text" v-else>{{
                      buscarTitulo(
                        props.item.descrCarroceria,
                        campos.descrCarroceriaList
                      )
                    }}</span>
                  </template>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="!erros[props.item.item].desativarCampoCarroceria.ativo">
                  <template v-if="erros[props.item.item].coberturaAdicionalCarroceria.ativo">

                    <v-edit-dialog
                      class="item-color"
                      :return-value.sync="props.item.vlrCarroceria"
                      lazy
                      large
                      persistent
                      @save="save"
                      @cancel="cancel"
                      @open="open"
                      @close="close"
                      save-text="Salvar"
                      cancel-text="Cancelar"
                      v-if="!camposDisabled"
                      >{{ formatMoney(props.item.vlrCarroceria)
                      }}<template v-slot:input>
                        <v-text-field
                          v-model="props.item.vlrCarroceria"
                          label="Editar"
                          single-line
                          :rules="regras.notNull"
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                    <span class="themeGrey--text" v-else>{{
                      formatMoney(props.item.vlrCarroceria)
                    }}</span>
                  </template>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="
                    erros[props.item.item].coberturaAdicionalEquipamentos.ativo
                  "
                >
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="
                      props.item.coberturaAdicionalEquipamentos
                    "
                    lazy
                    large
                    persistent
                    @save="saveEquipamentos(props.item.item, props.item.coberturaAdicionalEquipamentos)"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                  >
                    <span
                      :class="{
                        errorTaxa:
                          erros[props.item.item].coberturaAdicionalEquipamentos
                            .erro
                      }"
                      >{{
                        buscarTitulo(
                          props.item.coberturaAdicionalEquipamentos,
                          simOuNao
                        )
                      }}</span
                    >
                    <template v-slot:input>
                      <v-radio-group
                        v-model="props.item.coberturaAdicionalEquipamentos"
                        :mandatory="false"
                        row
                      >
                        <v-radio
                          v-for="item in simOuNao"
                          :key="item.titulo"
                          :label="item.titulo"
                          :value="item.id"
                        ></v-radio>
                      </v-radio-group>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    buscarTitulo(
                      props.item.coberturaAdicionalEquipamentos,
                      simOuNao
                    )
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="!erros[props.item.item].desativarCampoEquipamentos.ativo">
                  <template v-if="erros[props.item.item].coberturaAdicionalEquipamentos.ativo">
                    <v-edit-dialog
                      class="item-color"
                      :return-value.sync="props.item.descrEquipamentos"
                      lazy
                      large
                      persistent
                      @save="save"
                      @cancel="cancel"
                      @open="open"
                      @close="close"
                      save-text="Salvar"
                      cancel-text="Cancelar"
                      v-if="!camposDisabled"
                      >{{
                        buscarTitulo(
                          props.item.descrEquipamentos,
                          campos.descrEquipamentosList
                        )
                      }}
                      <template v-slot:input>
                        <v-select
                          :items="campos.descrEquipamentosList"
                          v-model="props.item.descrEquipamentos"
                          item-text="titulo"
                          :item-value="item => item"
                          label="Editar"
                          :rules="regras.notNull"
                          :value-comparator="comparador"
                        ></v-select>
                      </template>
                    </v-edit-dialog>
                    <span class="themeGrey--text" v-else>{{
                      buscarTitulo(
                        props.item.descrEquipamentos,
                        campos.descrEquipamentosList
                      )
                    }}</span>
                  </template>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="!erros[props.item.item].desativarCampoEquipamentos.ativo">
                  <template v-if="erros[props.item.item].coberturaAdicionalEquipamentos.ativo">
                    <v-edit-dialog
                      class="item-color"
                      :return-value.sync="props.item.vlrEquipamentos"
                      lazy
                      large
                      persistent
                      @save="save"
                      @cancel="cancel"
                      @open="open"
                      @close="close"
                      save-text="Salvar"
                      cancel-text="Cancelar"
                      v-if="!camposDisabled"
                      >{{ formatMoney(props.item.vlrEquipamentos)
                      }}<template v-slot:input>
                        <v-text-field
                          v-model="props.item.vlrEquipamentos"
                          label="Editar"
                          single-line
                          :rules="regras.notNull"
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                    <span class="themeGrey--text" v-else>{{
                      formatMoney(props.item.vlrEquipamentos)
                    }}</span>
                  </template>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="
                    erros[props.item.item].coberturaAdicionalAcessorios.ativo
                  "
                >
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.coberturaAdicionalAcessorios"
                    lazy
                    large
                    persistent
                    @save="saveAcessorios(props.item.item, props.item.coberturaAdicionalAcessorios)"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                  >
                    <span
                      :class="{
                        errorTaxa:
                          erros[props.item.item].coberturaAdicionalAcessorios
                            .erro
                      }"
                      >{{
                        buscarTitulo(
                          props.item.coberturaAdicionalAcessorios,
                          simOuNao
                        )
                      }}</span
                    >
                    <template v-slot:input>
                      <v-radio-group
                        v-model="props.item.coberturaAdicionalAcessorios"
                        :mandatory="false"
                        row
                      >
                        <v-radio
                          v-for="item in simOuNao"
                          :key="item.titulo"
                          :label="item.titulo"
                          :value="item.id"
                        ></v-radio>
                      </v-radio-group>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    buscarTitulo(
                      props.item.coberturaAdicionalAcessorios,
                      simOuNao
                    )
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="!erros[props.item.item].desativarCampoAcessorios.ativo">
                  <template v-if="erros[props.item.item].coberturaAdicionalAcessorios.ativo">

                    <v-edit-dialog
                      class="item-color"
                      :return-value.sync="props.item.descrAcessorios"
                      lazy
                      large
                      persistent
                      @save="save"
                      @cancel="cancel"
                      @open="open"
                      @close="close"
                      save-text="Salvar"
                      cancel-text="Cancelar"
                      v-if="!camposDisabled"
                      >{{
                        buscarTitulo(
                          props.item.descrAcessorios,
                          campos.descrAcessoriosList
                        )
                      }}
                      <template v-slot:input>
                        <v-select
                          :items="campos.descrAcessoriosList"
                          v-model="props.item.descrAcessorios"
                          item-text="titulo"
                          :item-value="item => item"
                          label="Editar"
                          :rules="regras.notNull"
                          :value-comparator="comparador"
                        ></v-select>
                      </template>
                    </v-edit-dialog>
                    <span class="themeGrey--text" v-else>{{
                      buscarTitulo(
                        props.item.descrAcessorios,
                        campos.descrAcessoriosList
                      )
                    }}</span>
                  </template>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="!erros[props.item.item].desativarCampoAcessorios.ativo">
                  <template v-if="erros[props.item.item].coberturaAdicionalAcessorios.ativo">

                    <v-edit-dialog
                      class="item-color"
                      :return-value.sync="props.item.vlrAcessorios"
                      lazy
                      large
                      persistent
                      @save="save"
                      @cancel="cancel"
                      @open="open"
                      @close="close"
                      save-text="Salvar"
                      cancel-text="Cancelar"
                      v-if="!camposDisabled"
                      >{{ formatMoney(props.item.vlrAcessorios)
                      }}<template v-slot:input>
                        <v-text-field
                          v-model="props.item.vlrAcessorios"
                          label="Editar"
                          single-line
                          :rules="regras.notNull"
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                    <span class="themeGrey--text" v-else>{{
                      formatMoney(props.item.vlrAcessorios)
                    }}</span>
                  </template>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.vlrBlindagem"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{ formatMoney(props.item.vlrBlindagem)
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.vlrBlindagem"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  formatMoney(props.item.vlrBlindagem)
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.vlrKitGas"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{ formatMoney(props.item.vlrKitGas)
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.vlrKitGas"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  formatMoney(props.item.vlrKitGas)
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.kmAssistencia"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{
                    buscarTitulo(
                      props.item.kmAssistencia,
                      campos.kmAssistenciaList
                    )
                  }}
                  <template v-slot:input>
                    <v-select
                      :items="campos.kmAssistenciaList"
                      v-model="props.item.kmAssistencia"
                      item-text="titulo"
                      :item-value="item => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item.kmAssistencia,
                    campos.kmAssistenciaList
                  )
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.carroReserva"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{
                    buscarTitulo(
                      props.item.carroReserva,
                      campos.carroReservaList
                    )
                  }}
                  <template v-slot:input>
                    <v-select
                      :items="campos.carroReservaList"
                      v-model="props.item.carroReserva"
                      item-text="titulo"
                      :item-value="item => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(props.item.carroReserva, campos.carroReservaList)
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-tooltip top v-if="categoriaSemCoberturaVidros(props.item)">
                  <template v-slot:activator="{ on }">
                    <span v-on="on" class="grey--text">Não aplicável</span>
                  </template>
                  <span>Categoria do veículo não possui cobertura de vidros.</span>
                </v-tooltip>
                <v-edit-dialog
                  v-else-if="!camposDisabled"
                  class="item-color"
                  :return-value.sync="props.item.coberturaVidros"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  >{{
                    buscarTitulo(
                      props.item.coberturaVidros,
                      campos.coberturaVidrosList
                    )
                  }}
                  <template v-slot:input>
                    <v-select
                      :items="opcoesVidros(props.item)"
                      v-model="props.item.coberturaVidros"
                      item-text="titulo"
                      :item-value="item => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item.coberturaVidros,
                    campos.coberturaVidrosList
                  )
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.tipoDeProposta"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{
                    buscarTitulo(
                      props.item.tipoDeProposta,
                      campos.tipoDePropostaList
                    )
                  }}
                  <template v-slot:input>
                    <v-select
                      :items="campos.tipoDePropostaList"
                      v-model="props.item.tipoDeProposta"
                      item-text="titulo"
                      :item-value="item => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item.tipoDeProposta,
                    campos.tipoDePropostaList
                  )
                }}</span>
              </td>
              <td class="themeGrey--text">
                <span class="themeGrey--text" v-if="camposDisabled">{{
                  buscarTitulo(props.item.classeBonus, campos.classeList)
                }}</span>
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.classeBonus"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-else-if="erros[props.item.item].classeBonus.ativo"
                >
                  <span
                    :class="{
                      errorTaxa: erros[props.item.item].classeBonus.erro
                    }"
                    >{{
                      buscarTitulo(props.item.classeBonus, campos.classeList)
                    }}</span
                  >
                  <template v-slot:input>
                    <v-select
                      :items="campos.classeList"
                      v-model="props.item.classeBonus"
                      item-text="titulo"
                      item-value="id"
                      label="Editar"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span text-start v-else>0</span>
              </td>

              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="erros[props.item.item].numeroApoliceAnterior.ativo"
                >
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.numeroApoliceAnterior"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                    ><span
                      :class="{
                        errorTaxa:
                          erros[props.item.item].numeroApoliceAnterior.erro
                      }"
                      >{{ props.item.numeroApoliceAnterior }}</span
                    >
                    <template v-slot:input>
                      <v-text-field
                        type="number"
                        v-model="props.item.numeroApoliceAnterior"
                        label="Editar"
                        single-line
                        :rules="regras.notNull"
                        mask="###############"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    props.item.numeroApoliceAnterior
                  }}</span>
                </template>
              </td>

              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="erros[props.item.item].numeroItemAnterior.ativo"
                >
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.numeroItemAnterior"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                    ><span
                      :class="{
                        errorTaxa:
                          erros[props.item.item].numeroItemAnterior.erro
                      }"
                      >{{ props.item.numeroItemAnterior }}</span
                    >
                    <template v-slot:input>
                      <v-text-field
                        type="number"
                        v-model="props.item.numeroItemAnterior"
                        label="Editar"
                        single-line
                        :rules="regras.notNull"
                        mask="######"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    props.item.numeroItemAnterior
                  }}</span>
                </template>
              </td>

              <td class="themeGrey--text">
                <span class="themeGrey--text" v-if="camposDisabled">{{
                  buscarTitulo(
                    props.item.renovacaoComSinistro,
                    campos.renovacaoSinistroOptions
                  )
                }}</span>
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.renovacaoComSinistro"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-else-if="erros[props.item.item].renovacaoComSinistro.ativo"
                >
                  <span
                    :class="{
                      errorTaxa:
                        erros[props.item.item].renovacaoComSinistro.erro
                    }"
                    >{{
                      buscarTitulo(
                        props.item.renovacaoComSinistro,
                        campos.renovacaoSinistroOptions
                      )
                    }}</span
                  >
                  <template v-slot:input>
                    <v-radio-group
                      v-model="props.item.renovacaoComSinistro"
                      :mandatory="false"
                      row
                    >
                      <v-radio
                        v-for="item in campos.renovacaoSinistroOptions"
                        :key="item.titulo"
                        :label="item.titulo"
                        :value="item.id"
                      ></v-radio>
                    </v-radio-group>
                  </template>
                </v-edit-dialog>
                <span v-else> Não se Aplica </span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.ciaRenovacao"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{
                    buscarTitulo(
                      props.item.ciaRenovacao,
                      campos.ciaRenovacaoList
                    )
                  }}
                  <template v-slot:input>
                    <v-select
                      :items="campos.ciaRenovacaoList"
                      v-model="props.item.ciaRenovacao"
                      item-text="titulo"
                      :item-value="item => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(props.item.ciaRenovacao, campos.ciaRenovacaoList)
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.codRenovacao"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{ props.item.codRenovacao
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.codRenovacao"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  props.item.codRenovacao
                }}</span>
              </td>
            </template>
            <template v-slot:pageText="props">
              {{ props.pageStart }} - {{ props.pageStop }} de
              {{ props.itemsLength }}
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning">
                Sua pesquisa não foi encontrada.
              </v-alert>
            </template>
          </v-data-table>
          <v-snackbar v-model="snack" :timeout="3500" :auto-height="true" :color="snackColor">
            {{ snackText }}
            <v-btn flat @click="snack = false">Fechar</v-btn>
          </v-snackbar>
        </v-card>
      </v-form>
    <v-divider></v-divider>
    </v-container>
    <v-layout row class="d-flex pa-3" style="justify-content: space-between;background-color: #f2f2f2">
      <v-flex md2>
        <v-btn color="primary" style="width: 100%" @click="$emit('voltar')" flat> Voltar </v-btn>
      </v-flex>
      <v-flex md2>
        <v-btn
          v-if="!visualizarModal"
          class="primary"
          elevation="2"
          right
          style="width: 86%"
          @click="solicitaCalculo"
          >Próximo</v-btn
        >
        <v-btn
          v-else
          class="primary"
          elevation="2"
          right
          style="width: 86%"
          @click="$emit('atualizar')"
          >Fechar</v-btn
        >
      </v-flex>
    </v-layout>
    
    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="showTermoAceite" max-width="850px">
          <ModalTermosAceite
            :visible="showTermoAceite"
            @close="showTermoAceite = false"
            @next="onAceiteTermos"
          />
        </v-dialog>
      </v-layout>
    </template>

    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogSolicitacao" max-width="850px">
          <ModalSolicitacaoCorretorReserva
            @fechar="onVoltarModal"
            @fecharTudo="dialogSolicitacao = false; $emit('fechar')"
            :dialog="dialogSolicitacao"
            @atualizar="$emit('atualizar')"
          />
        </v-dialog>
      </v-layout>
    </template>

  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import CustomFormat from '@/helpers/custom-format'
import usuarioHelper from "@/helpers/usuario-logado.js";
import ModalSolicitacaoCorretorReserva from "./ModalSolicitacaoCorretorReserva.vue";
import ModalTermosAceite from "../solicitacao-cotacao-analista/ModalTermosAceite.vue";
import tipoCoberturaEnum from "@/helpers/tipo-cobertura-enum.js"
import { adicionarId } from "@/helpers/url-helper.js";
import coberturaVidrosHelper from "@/helpers/cobertura-vidros.js";
import despesasExtrasHelper from "@/helpers/despesas-extras";

export default {
  name: "ModalCoberturas",
  props: {
    visualizarCoberturas: {
      type: Boolean,
      required: false
    }
  },
  components: {
    ModalSolicitacaoCorretorReserva,
    ModalTermosAceite
  },
  data() {
    return {
      menu: false,
      filtrarErros: false,
      simOuNao: [
        {
          id: true,
          titulo: "Sim"
        },
        {
          id: false,
          titulo: "Não"
        }
      ],
      headers: [
        { text: "ITEM", value: "item", class: "item-primary" },
        { text: "", value: "", notSortable: false, class: "pa-0" },
        {
          text: "PLACA",
          align: "left",
          value: "placa"
        },
        { text: "TIPO DE COBERTURA", value: "tipoCobertura" },
        { text: "TIPO DE CONTRATAÇÃO", value: "tipoDeContratacao" },
        { text: "% AJUSTE VMR/VD", value: "percAjusteVmrOuVd" },
        { text: "TIPO DE FRANQUIA", value: "tipoDeFranquia" },
        { text: "VLR. FIPE", value: "vlrFipe" },
        { text: "VD CONTRATADO", value: "vdContratado" },
        { text: "DANOS MATERIAIS", value: "danosMateriais" },
        {
          text: "VLR. FRANQUIA DM",
          value: "vlrFranquiaDanosMateriais"
        },
        { text: "DANOS CORPORAIS", value: "danosCorporais" },
        { text: "DANOS MORAIS E ESTÉTICOS", value: "danosMoraisEEsteticos" },
        { text: "GARANTIA ÚNICA", value: "garantiaUnica" },
        { text: "VLR. GARANTIA ÚNICA", value: "vlrGarantiaUnica" },
        {
          text: "VLR. FRANQUIA GARANTIA ÚNICA",
          value: "vlrFranquiaGarantiaUnica"
        },
        { text: "APP MORTE", value: "appMorte" },
        { text: "APP INVALIDEZ", value: "appInvalidez" },
        {
          text: "DMHO",
          value: "despesasMedicasHospitalaresEOdontologicas",
          tool: "DESP. MÉDICAS, HOSPITALARES E ODONTOLÓGICAS"
        },
        {
          text: "AD. DESP. EXTRA",
          value: "coberturaAdicionalDespesasExtras",
          tool: "COBERTURA ADICIONAL: DESPESAS EXTRAS"
        },
        { text: "DESPESAS EXTRAS", value: "despesasExtras" },
        { text: "CAMINHÃO BASCULADO", value: "caminhaoBasculado" },
        { text: "DIAS DE GARANTIA ZERO KM", value: "diasGarantZeroKm" },
        {
          text: "COMPREENSIVA: TUMULTOS",
          value: "garantiaCompreensivaParaTumultos",
          tool: "GARANTIA COMPREENSIVA PARA TUMULTOS"
        },
        { text: "EXT. COB. AMÉRICA DO SUL", value: "extCobAmericaDoSul" },
        { text: "RCF - EXT. COB. AMÉRICA DO SUL",
          value: "rcfExtCobAmericaDoSul",
          tool: "RCF - EXT. DE PERÍMETRO PARA AMÉRICA DO SUL"
        },
        { text: "VLR. RCF - EXT. COB. AMÉRICA DO SUL", value: "vlrRcfExtCobAmericaDoSul" },
        {
          text: "DANOS MAT. DIRIGENTES ETC",
          value: "danosMateriaisADirigentesSociosEmpregadosEPrepostos",
          tool: "DANOS MATERIAIS: DIRIGENTES, SÓCIOS, EMPREG. & PREPOSTOS"
        },
        { text: "VLR. DANOS MAT. DIRIGENTES ETC", value: "vlrDanosMateriaisADirigentesSociosEmpregadosEPrepostos" },

        {
          text: "DANOS CORP. DIRIGENTES ETC",
          value: "danosCorporaisADirigentesSociosEmpregadosEPrepostos",
          tool: "DANOS CORPORAIS: DIRIGENTES, SÓCIOS, EMPREG. & PREPOSTOS"
        },
        { text: "VLR. DANOS CORP. DIRIGENTES ETC", value: "vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos" },
        {
          text: "DANOS A TERCEIROS",
          value:
            "danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado",
          tool:
            "DANOS MATERIAIS/CORPORAIS, CAUSADO POR REBOQUE/SEMIRREBOQUE DESATRELADO"
        },
        {
          text: "EXT. RCF VEÍC. REBOCADOS",
          value: "extensaoDeCoberturaRcfAVeiculosRebocados",
          tool: "EXTENSÃO DE COBERTURA RCF A VEÍCULOS REBOCADOS"
        },
        {
          text: "AD. CARROCERIA",
          value: "coberturaAdicionalCarroceria",
          tool: "COBERTURA ADICIONAL: CARROCERIA"
        },
        { text: "DESCR. DA CARROCERIA", value: "descrCarroceria" },
        { text: "VLR. CARROCERIA", value: "vlrCarroceria" },
        {
          text: "AD. EQUIPAMENTOS",
          value: "coberturaAdicionalEquipamentos",
          tool: "COBERTURA ADICIONAL: EQUIPAMENTOS"
        },
        { text: "DESCR. DO EQUIPAMENTO", value: "descEquipamentos" },
        { text: "VLR. EQUIPAMENTO", value: "vlrEquipamentos" },
        {
          text: "AD. ACESSÓRIOS",
          value: "coberturaAdicionalAcessorios",
          tool: "COBERTURA ADICIONAL: ACESSÓRIOS"
        },
        { text: "DESCR. DO ACESSÓRIO", value: "descAcessorios" },
        { text: "VLR. ACESSÓRIO", value: "vlrAcessorios" },
        { text: "VLR. BLINDAGEM", value: "vlrBlindagem" },
        { text: "VLR. KIT GÁS", value: "vlrKitGas" },
        { text: "KM ASSISTÊNCIA", value: "kmAssistencia" },
        { text: "CARROS RESERVA", value: "carroReserva" },
        { text: "COBERTURA VIDROS", value: "coberturaVidros" },
        { text: "TIPO DE PROPOSTA", value: "tipoDeProposta" },
        { text: "CLASSE", value: "classeBonus" },
        { text: "Nº APÓLICE ANTERIOR", value: "numeroApoliceAnterior" },
        { text: "NÚMERO ANTERIOR", value: "numeroItemAnterior" },
        { text: "TIPO DE RENOVAÇÃO", value: "renovacaoComSinistro" },
        { text: "CIA. RENOVAÇÃO", value: "ciaRenovacao" },
        { text: "CÓD. RENOVAÇÃO", value: "codRenovacao" }
      ],
      snack: false,
      snackColor: "",
      snackText: "",
      dialog: false,
      dialogSolicitacao: false,
      showTermoAceite: false,
      regras: {
        notNull: [v => !!v || "Você não pode deixar este campo em branco"],
        limites: ({ min, max }) => [
          v =>
            +v === 0 ||
            (v >= min && v <= max) ||
            `O valor precisa ser entre ${min} e ${max}`
        ]
      },
      pagination: {
        sortBy: "name"
      },
      selected: [],
      filtro: {
        pesquisa: {
          opened: false,
          conteudo: ""
        }
      },
      camposInfoGerais: {
        formaPagamentoList: [],
        idFormaPagamento: null,
        parcelamentoList: [],
        idParcelamento: null,
        dataPrimeiraParcela: null,
        apoliceIof: null,
        corretagem: null
      },
      campos: {
        tipoCoberturaList: [],
        tipoDeContratacaoList: [],
        tipoDeFranquiaList: [],
        tipoDePropostaList: [],
        ciaRenovacaoList: [],
        kmAssistenciaList: [],
        carroReservaList: [],
        descrCarroceriaList: [],
        descrEquipamentosList: [],
        descrAcessoriosList: [],
        coberturaVidrosList: [],
        vlrFranquiaDanosMateriaisList: [],
        vlrFranquiaGarantiaUnicaList: [],
        diasGarantZeroKmList: [],
        classeList: new Array(11).fill({}).map((_, index) => ({
          id: index,
          titulo: `${index}`
        })),
        renovacaoSinistroOptions: [
          {
            id: true,
            titulo: "Com sinistro"
          },
          {
            id: false,
            titulo: "Sem Sinistro"
          }
        ]
      },
      dadosPlanilha: [],
      resultados: {
        totalAp: null,
        totalCoberturaCompensativa: null,
        totalCoberturaRcf: null,
        totalCoberturasAdicionais: null,
        totalFranquiaCoberturaAcessorios: null,
        totalFranquiaCoberturaCarroceria: null,
        totalFranquiaCoberturaCompensativa: null,
        totalFranquiaCoberturaEquipamentos: null,
        totalPremio: null,
        totalServicosAgregados: null
      },
      limitesTaxasBasicas: {
        danosMateriais: {},
        danosCorporais: {},
        danosMoraisEEsteticos: {},
        danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado: {},
        appMorte: {},
        appInvalidez: {},
        despesasMedicasHospitalaresEOdontologicas: {},
        vlrGarantiaUnica: {},
        vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos: {},
        vlrDanosMateriaisADirigentesSociosEmpregadosEPrepostos: {}

      },
      idApolice: null
    };
  },
  computed: {
    camposDisabled() {
      return this.visualizarCoberturas == true;
    },
    visualizarModal() {
      return this.visualizarCoberturas == true;
    },
    ...mapState("formCorretorReserva", [
      "apoliceNumeroProposta",
      "idPropostaStatus",
      "id",
      "proponenteCnpj",
      "proponenteRazaoSocial",
      "quantidadeItens",
      "dateInicio",
      "dateFim",
      "valoresPremioTotal"
    ]),

    tipoCoberturaComputed() {
      return tipoCoberturaEnum;
    },

    errosFiltrados() {
      return this.filtrarErros && this.numeroErros
        ? this.dadosPlanilha.filter(value => value.erro)
        : this.dadosPlanilha;
    },
    numeroErros() {
      return Object.values(this.erroPlanilha).reduce(
        (acc, cur) => (cur ? acc + 1 : acc),
        0
      );
    },
    erroPlanilha() {
      return this.formatarErro(this.dadosPlanilha);
    },

    proximoIndice() {
      return (
        this.dadosPlanilha.reduce(
          (acc, cur) => (cur.item > acc ? cur.item : acc),
          -1
        ) + 1
      );
    },

    textPrimeiraParcela() {
      return new Date(this.calculoDataPrimeiraParcela).toLocaleDateString(
        "pt-BR",
        {
          timeZone: "UTC",
          year: "numeric",
          month: "long",
          day: "numeric"
        }
      );
    },

    erros() {
      const validar = (ativo, temErro) => {
        if (!ativo) {
          return { ativo: false };
        }
        return {
          ativo: true,
          erro: temErro()
        };
      };
      return this.dadosPlanilha.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.item]: {
            danosMateriais: validar(true, () =>
              this.limiteExcedido(
                this.limitesTaxasBasicas.danosMateriais,
                cur.danosMateriais
              )
            ),
            vlrFranquiaDanosMateriais: validar(
              cur.danosMateriais !== "" && cur.danosMateriais !== null,
              () => ({})
            ),
            danosCorporais: validar(true, () =>
              this.limiteExcedido(
                this.limitesTaxasBasicas.danosCorporais,
                cur.danosCorporais
              )
            ),
            danosMoraisEEsteticos: validar(true, () =>
              this.limiteExcedido(
                this.limitesTaxasBasicas.danosMoraisEEsteticos,
                cur.danosMoraisEEsteticos
              )
            ),
            appMorte: validar(true, () =>
              this.limiteExcedido(
                this.limitesTaxasBasicas.appMorte,
                cur.appMorte
              )
            ),
            appInvalidez: validar(true, () =>
              this.limiteExcedido(
                this.limitesTaxasBasicas.appInvalidez,
                cur.appInvalidez
              )
            ),
            despesasMedicasHospitalaresEOdontologicas: validar(true, () =>
              this.limiteExcedido(
                this.limitesTaxasBasicas
                  .despesasMedicasHospitalaresEOdontologicas,
                cur.despesasMedicasHospitalaresEOdontologicas
              )
            ),
            danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado: validar(
              true,
              () =>
                this.limiteExcedido(
                  this.limitesTaxasBasicas
                    .danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado,
                  cur.danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
                )
            ),

            //--//
            vlrGarantiaUnica: validar(cur.garantiaUnica === true, () =>
              this.limiteExcedido(
                this.limitesTaxasBasicas.vlrGarantiaUnica,
                cur.vlrGarantiaUnica
              )
            ),
            vlrFranquiaGarantiaUnica: validar(
              cur.garantiaUnica === true,
              () => ({})
            ),
            tipoDeContratacao: validar(cur.tipoCobertura.id === 3, () =>
              cur.tipoDeContratacao = null
            ),
            percAjusteVmrOuVd: validar(cur.tipoCobertura.id === 3, () =>
              cur.percAjusteVmrOuVd = null
            ),
            tipoDeFranquia: validar(cur.tipoCobertura.id === 3, () =>
              cur.tipoDeFranquia = null
            ),
            vdContratado: validar(
              cur.tipoCobertura &&
              [1, 2, 4].includes(cur.tipoCobertura.id) &&
              cur.tipoDeContratacao &&
              cur.tipoDeContratacao.id === 1,
              () => {}
            ),
            vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos: validar(true, () =>
                this.limitesTaxasBasicas.vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos,
                cur.vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos

            ),
            vlrDanosMateriaisADirigentesSociosEmpregadosEPrepostos: validar(true, () =>
                this.limitesTaxasBasicas.vlrDanosMateriaisADirigentesSociosEmpregadosEPrepostos,
                cur.vlrDanosMateriaisADirigentesSociosEmpregadosEPrepostos

            ),
            classeBonus: validar(
              true,
              () =>
                !!(
                  cur.tipoDeProposta &&
                  cur.tipoDeProposta.id === 2 &&
                  cur.classeBonus
                )
            ),

            numeroApoliceAnterior: {
              ativo: cur.tipoDeProposta && cur.tipoDeProposta.id !== 2
            },

            numeroItemAnterior: {
              ativo: cur.tipoDeProposta && cur.tipoDeProposta.id !== 2
            },

            extCobAmericaDoSul: validar(
              cur.tipoCobertura &&
              cur.tipoCobertura.id === tipoCoberturaEnum.tipoCobertura.RCF,
              () => cur.extCobAmericaDoSul = false
            ),
            vlrRcfExtCobAmericaDoSul: validar(
              cur.rcfExtCobAmericaDoSul === true,
              () => cur.vlrRcfExtCobAmericaDoSul = Number(cur.danosMateriais) +
              Number(cur.danosCorporais) + Number(cur.vlrGarantiaUnica)
            ),
            renovacaoComSinistro: validar(
              cur.tipoDeProposta &&
                cur.tipoDeProposta.id === 1 &&
                cur.classeBonus > 0,
              () => typeof cur.renovacaoComSinistro !== "boolean"
            ),
            desativarCampoCarroceria: validar(
              !cur.coberturaAdicionalCarroceria, () => typeof cur.coberturaAdicionalCarroceria !== "boolean"
            ),
            desativarCampoEquipamentos: validar(
              !cur.coberturaAdicionalEquipamentos, () => typeof cur.coberturaAdicionalEquipamentos !== "boolean"
            ),
            desativarCampoAcessorios: validar(
              !cur.coberturaAdicionalAcessorios, () => typeof cur.coberturaAdicionalAcessorios !== "boolean"
            ),
            desativarCampoDespesasExtras: validar(
              !cur.coberturaAdicionalDespesasExtras, () => typeof cur.coberturaAdicionalDespesasExtras !== "boolean"
            ),
            desativarDanosMateriaisADirigentesSociosEmpregadosEPrepostos: validar(
              !cur.danosMateriaisADirigentesSociosEmpregadosEPrepostos,
              () => typeof cur.danosMateriaisADirigentesSociosEmpregadosEPrepostos !== "boolean"
            ),
            desativarDanosCorporaisADirigentesSociosEmpregadosEPrepostos: validar(
              !cur.danosCorporaisADirigentesSociosEmpregadosEPrepostos,
              () => typeof cur.danosCorporaisADirigentesSociosEmpregadosEPrepostos !== "boolean"
            ),
            desativarRcfExtCobAmericaDoSul: validar(
              !cur.rcfExtCobAmericaDoSul,
              () => typeof cur.rcfExtCobAmericaDoSul !== "boolean"
            ),

            ...Object.fromEntries(
              [
                "coberturaAdicionalCarroceria",
                "coberturaAdicionalEquipamentos",
                "coberturaAdicionalAcessorios",
                "coberturaAdicionalDespesasExtras"
              ].map(key => [
                key,
                validar(
                  cur.tipoCobertura && [1, 2, 4].includes(cur.tipoCobertura.id),
                  () => typeof cur[key] !== "boolean"
                )
              ])
            )
          }
        }),
        {}
      );
    }
  },

  mounted() {

    this.dadosPlanilha = this.$store.getters[
      "formCorretorReserva/cloneConteudoPlanilha"
    ];
    this.buscaLimitesTaxas();
    this.buscaOpcoes();
  },

  methods: {
    toPercentString: function (val) {
        return CustomFormat.toPercentString(val);
    },
    categoriaSemCoberturaVidros(item) {
      return !!(item && item.catVeiculo && item.catVeiculo.id === 6);
    },
    opcoesVidros(item) {
      return coberturaVidrosHelper.filtrarOpcoes(
        this.campos.coberturaVidrosList,
        item && item.catVeiculo
      );
    },

    normalizarVidrosTodosItens() {
      coberturaVidrosHelper.normalizarLista(
        this.dadosPlanilha,
        this.campos.coberturaVidrosList
      );
    },
    findArrayIndex(item) {
      return this.dadosPlanilha.findIndex(element => element.item == item);

    },
    disableCamposCarroceria(item, ativo) {
      if(!ativo) {
        this.dadosPlanilha[this.findArrayIndex(item)].descrCarroceria = null;
        this.dadosPlanilha[this.findArrayIndex(item)].vlrCarroceria = null;
      }
    },
    disableCamposEquipamentos(item, ativo) {
      if(!ativo) {
        this.dadosPlanilha[this.findArrayIndex(item)].descrEquipamentos = null;
        this.dadosPlanilha[this.findArrayIndex(item)].vlrEquipamentos = null;
      }
    },
    disableCamposAcessorios(item, ativo) {
      if(!ativo) {
        this.dadosPlanilha[this.findArrayIndex(item)].descrAcessorios = null;
        this.dadosPlanilha[this.findArrayIndex(item)].vlrAcessorios = null;
      }
    },
    disableCamposDepesasExtras(item, ativo) {
      if (!ativo) {
        this.dadosPlanilha[this.findArrayIndex(item)].despesasExtras = null;
      } else {
        despesasExtrasHelper.aplicarValorFixo(
          this.dadosPlanilha[this.findArrayIndex(item)],
          this.limitesTaxasBasicas.valorFixoDespesasExtras
        );
      }
    },
    disableCamposDmADirigentes(item, ativo) {
      if(!ativo) {
        this.dadosPlanilha[this.findArrayIndex(item)].vlrDmDirigenteSociosEmpregadosPrepostos = null;
      }
    },
    disableCamposDcADirigentes(item, ativo) {
      if(!ativo) {
        this.dadosPlanilha[this.findArrayIndex(item)].vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos = null;
      }
    },
    disableCamposVlrRcfExtCobAmericaDoSul(item, ativo) {
      if(!ativo) {
        this.dadosPlanilha[this.findArrayIndex(item)].vlrRcfExtCobAmericaDoSul = null;
      }
    },
    disableCampoVlrGarantiaUnica(item, ativo) {
      if(!ativo) {
        this.dadosPlanilha[this.findArrayIndex(item)].vlrGarantiaUnica = null;
      }
    },
    saveCarroceria(item, ativo) {
      this.save();
      this.disableCamposCarroceria(item, ativo)
    },
    saveEquipamentos(item, ativo) {
      this.save();
      this.disableCamposEquipamentos(item, ativo)
    },
    saveAcessorios(item, ativo) {
      this.save();
      this.disableCamposAcessorios(item, ativo)
    },
    saveDespesasExtras(item, ativo) {
      this.save();
      this.disableCamposDepesasExtras(item, ativo)
    },
    saveDmDiregentes(item, ativo) {
      this.save();
      this.disableCamposDmADirigentes(item, ativo)
    },
    saveDcDiregentes(item, ativo) {
      this.save();
      this.disableCamposDcADirigentes(item, ativo)
    },
    saveRcfExtCobAmericaDoSul(item, ativo) {
      this.save();
      this.disableCamposVlrRcfExtCobAmericaDoSul(item, ativo)
    },
    saveGarantiaUnica(item, ativo) {
      this.save();
      this.disableCampoVlrGarantiaUnica(item, ativo)
    },
    formatarErro(novosErros, listaErros = {}) {
      return {
        ...listaErros,
        ...novosErros.reduce(
          (acc, cur) => ({ ...acc, [cur.item]: cur.erro }),
          {}
        )
      };
    },

    totaisCalculados() {
      return this.$store.getters["formCorretorReserva/totais"];
    },

    formatarCnpj(cnpj) {
      if (typeof cnpj === "string" && cnpj.match(/^[A-Za-z0-9]{12}\d{2}$/)) {
        return cnpj.replace(
          /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
          "$1.$2.$3/$4-$5"
        );
      }
      return "";
    },
    formatarData(data) {
      return new Date(data).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "numeric",
        day: "numeric"
      });
    },

    formatarNumeroItem(item) {
      const numero = `000${item}`;
      return numero.slice(numero.length - 3);
    },

    formatMoney(amount) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      }).format(amount || 0);
    },

    buscarTitulo(entity, list) {
      if (entity !== null && entity !== undefined) {
        const campo = list.find(
          item => item.id === entity || item.id === entity.id
        );
        if (campo) {
          return campo.titulo;
        }
      }
      return "-";
    },
    comparador(itemLista, item) {
      if (item && item.id !== null && item.id !== undefined) {
        return item.id === itemLista.id;
      }
      return false;
    },
    deletarItens() {
      const selecionados = this.selected.map(e => e.item);
      this.dadosPlanilha = this.dadosPlanilha.filter(
        e => !selecionados.includes(e.item)
      );
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.dadosPlanilha.slice();
    },
    filtroFunctions: function() {
      const self = this;
      return {
        abrirFiltroPesquisa: function() {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function() {
          if (
            !self.filtro.pesquisa.conteudo ||
            self.filtro.pesquisa.conteudo == ""
          ) {
            self.filtro.pesquisa.opened = false;
          }
        }
      };
    },
    buscaOpcoes() {
      axios
        .get(`${process.env.URL_PLANILHAMS}/v1/buscarOpcoesCampos/`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          [
            "tipoVeiculoList",
            "catVeiculoList",
            "ufPernoiteList",
            "usoDoVeiculoList",
            "propriedadeRegistroDoCrlvList",
            "diasGarantZeroKmList",
            "tipoCoberturaList",
            "tipoDeContratacaoList",
            "tipoDeFranquiaList",
            "tipoDePropostaList",
            "ciaRenovacaoList",
            "kmAssistenciaList",
            "carroReservaList",
            "descrCarroceriaList",
            "descrEquipamentosList",
            "descrAcessoriosList",
            "coberturaVidrosList",
            "vlrFranquiaDanosMateriaisList",
            "vlrFranquiaGarantiaUnicaList"
          ].forEach(nome => {
            this.campos[nome] =
              response.data[nome] instanceof Array ? response.data[nome] : [];
          });
          this.campos.coberturaVidrosList = coberturaVidrosHelper.comOpcaoNenhuma(
            this.campos.coberturaVidrosList
          );
          this.normalizarVidrosTodosItens();
        })
        .catch(err => {
          console.error(err);
        });
    },
    solicitaCalculo() {
      this.normalizarVidrosTodosItens();
      if (!this.validaColunas()) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText =
          "Não foi possível calcular porque há valores fora da faixa permitida. Corrija os campos em vermelho e tente novamente.";
      } else {
        const dadosAtualizados = {
          dados: this.dadosPlanilha
        };
        this.$store.commit("formCorretorReserva/setConteudoPlanilha", dadosAtualizados);
        for (var item of dadosAtualizados.dados) {
          if (item.garantiaUnica === null) {
            this.snack = true;
            this.snackColor = "error";
            this.snackText =
              `[Erro no item: ${item.item}]: Campo garantia única inválido. Deve estar preenchido com SIM ou NÃO.`;
            return
          }
          if (item.tipoDeContratacao && item.tipoDeContratacao.id === 2 && item.vdContratado !== null || item.tipoCobertura.id === 3 && item.vdContratado !== null) {
            item.vdContratado = null;
          }
          if (item.tipoCobertura.id === 1 && (item.tipoDeContratacao === null || !item.percAjusteVmrOuVd || item.tipoDeFranquia === null)) {
            this.snack = true;
            this.snackColor = "error";
            this.snackText =
            `[Erro no item: ${item.item}] Para cobertura Compreensiva, campos 'Tipo de Contratação', '% Ajuste VMR/VD' e 'Tipo de Franquia' devem estar preenchidos.`;
            return
          }
          if (item.tipoCobertura.id === 1 && item.tipoDeContratacao && item.tipoDeContratacao.id === 1 &&
            (!item.percAjusteVmrOuVd || item.tipoDeFranquia === null || item.vdContratado === null)) {
              this.snack = true;
              this.snackColor = "error";
              this.snackText =
              `[Erro no item: ${item.item}] Para cobertura Compreensiva de tipo VD, os campos '% Ajuste VMR/VD', 'Tipo de Franquia' e 'VD Contratado' devem estar preenchidos.`;
              return
          }
          if (item.rcfExtCobAmericaDoSul === true && !item.danosMateriais && !item.danosCorporais && !item.vlrGarantiaUnica) {
            this.snack = true;
            this.snackColor = "error";
            this.snackText =
            `[Erro no cálculo do item: ${item.item}] A cobertura 'RCF - Extensão de Cobertura de Perímetro do Seguro aos Países da América do Sul' foi contratada. Informe pelo menos um valor para Danos Materiais, Danos Corporais ou Garantia Única para prosseguir.`;
            return
          }
        }
        axios
          .post(
            `${process.env.URL_CALCULOMS}/v1/calcularProposta`,
            this.$store.getters["formCorretorReserva/conteudoCalculoPlanilha"],
            {
              headers: {
                Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
              }
            }
          )
          .then(response => {
            Object.keys(this.resultados).forEach(item => {
              this.resultados[item] = response.data[item];
            });
            this.showTermoAceite = true;
          })
          .catch(error => {
            this.snack = true;
            this.snackColor = "error";
            error.response.data.message
              ? (this.snackText = error.response.data.message)
              : (this.snackText = "generico");
          });
      }
    },
    async buscaLimitesTaxas() {
      const respostaLimitesTaxas = await axios.post(
        `${process.env.URL_CALCULOMS}/v1/limitesTaxasBasicas`,
        this.dadosPlanilha
          .filter(veiculo => veiculo.catVeiculo && veiculo.catVeiculo.id !== 6)
          .map(veiculo =>
            ["item", "fipe", "anoMod", "tipoVeiculo"].reduce((acc, cur) => {
              acc[cur] = veiculo[cur];

              return acc;
            }, {})
          ),
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      if (respostaLimitesTaxas.data) {
        this.limitesTaxasBasicas = respostaLimitesTaxas.data;
        despesasExtrasHelper.aplicarValorFixo(
          this.dadosPlanilha,
          this.limitesTaxasBasicas.valorFixoDespesasExtras
        );
      }
    },
    validaColunas() {
      return Object.values(this.erros).every(item =>
        Object.values(item).every(subItem => subItem.erro !== true)
      );
    },
    save() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Item salvo";
    },
    cancel() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Editar cancelado";
    },
    open() {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Editar aberto";
    },
    close() {},
    limiteExcedido({ min, max }, value) {
      return +value !== 0 && (value < min || value > max);
    },
    formatarNumeroCotacao(item) {
      if (item != null) {
        const numero = `000000${item}`;
        return numero.slice(numero.length - 6);
      }
    },
    formatarNumeroApolice(item) {
      if (item != null) {
        return item;
      }
    },
    onAceiteTermos() {
      this.showTermoAceite = false;
      this.dialogSolicitacao = true;
    },
    onVoltarModal() {
      this.dialogSolicitacao = false;
      this.showTermoAceite = true;
    }
  }
};
</script>

<style scoped>
.background {
  background-color: white;
}

.item-primary .v-menu__activator {
  display: flex;
  justify-content: center;
  text-align: center !important;
}

.item-color > div > a {
  color: #757575 !important;
}

.errorTaxa {
  color: red !important;
  font-weight: bold;
}

.button-permanecer {
  background: #00456e;
  color: #fff !important;
}

.text-permanecer {
  font-weight: bold;
  color: #757575 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/corretor-reserva/ModalCoberturas.vue